import React from 'react';
import styled from 'styled-components';
import Colours from './styled/Colours';

const half = '15px';
const full = '30px';

const StyledLoader = styled.div`
  height: ${full};
  width: ${full};
  position: relative;

  .spinner {
    position: absolute;
    width: ${full};
    height: ${full};

    .blob {
      position: absolute;
      top: ${half};
      left: ${half};
      border: 2px solid ${Colours.primary};
      width: 10px;
      height: 10px;
      border-radius: 50%;

      &.top {
        top: 0;
        animation: blob-top 1s infinite ease-in;
      }
      &.bottom {
        top: ${full};
        animation: blob-bottom 1s infinite ease-in;
      }
      &.left {
        left: 0;
        animation: blob-left 1s infinite ease-in;
      }
    }

    .move-blob {
      background: ${Colours.primary};
      margin-top: 0;
      animation: blob-spinner-mover 1s infinite ease-in;
    }
  }

  @keyframes blob-bottom {
    25%,
    50%,
    75% {
      top: ${half};
      left: ${full};
    }
    100% {
      top: 0;
      left: ${half};
    }
  }
  @keyframes blob-left {
    25% {
      top: ${half};
      left: 0;
    }
    50%,
    100% {
      top: ${full};
      left: ${half};
    }
  }
  @keyframes blob-top {
    50% {
      top: 0;
      left: ${half};
    }
    75%,
    100% {
      top: ${half};
      left: 0;
    }
  }
  @keyframes blob-spinner-mover {
    0%,
    100% {
      top: 0;
      left: ${half};
    }
    25% {
      top: ${half};
      left: ${full};
    }
    50% {
      top: ${full};
      left: ${half};
    }
    75% {
      top: ${half};
      left: 0;
    }
  }
`;

const BlobLoader = () => (
  <StyledLoader>
    <div className="spinner">
      <div className="blob top" />
      <div className="blob bottom" />
      <div className="blob left" />
      <div className="blob move-blob" />
    </div>
  </StyledLoader>
);

export default BlobLoader;
